export enum AppointmentsRescheduleDataTestId {
  APPOINTMENT_RESCHEDULE_CONFIRM_PROCEDURE = 'appointments--reschedule-confirm-procedure',
  APPOINTMENT_RESCHEDULE_CONFIRM_DATE = 'appointments--reschedule-confirm-date',
  APPOINTMENT_RESCHEDULE_CONFIRM_PROFESSIONAL = 'appointments--reschedule-confirm-professional',
  APPOINTMENT_RESCHEDULE_CONFIRM_HOUR = 'appointments--reschedule-confirm-hour',
  APPOINTMENT_RESCHEDULE_BUTTON_BACK = 'appointments--reschedule-button-back',
  APPOINTMENT_RESCHEDULE_BUTTON_SUBMIT = 'appointments--rechedule-button-submit',
  APPOINTMENT_RESCHEDULE_CALENDAR = 'appointments--reschedule-calendar',
  APPOINTMENT_RESCHEDULE_TABS = 'appointments--reschedule-tabs',
}
